/* Reference In Time — accessible names for header controls (19 Aug 2026)

   Lighthouse and the Agentic Browsing audit both flagged two header
   elements with no discernible name:
     • the logo link  (header.theme-header #identity #logo a[href="/"])
     • the search submit button (form.header-search-form ... button)
   Both are also SEO signals (anchor context) and both are read by AI
   browsing agents through the accessibility tree, so naming them pays
   off three ways at once.

   This runs as a light pass rather than joining the rit-fixes.js
   MutationObserver pipeline — the header is rendered server-side and
   does not change after load, so a few passes are enough and a second
   always-on observer is avoided.

   Every step is idempotent and only ever ADDS a name when one is
   genuinely missing; nothing existing is overwritten. */
(function () {
  'use strict';

  var SHOP_NAME = 'Reference In Time';

  function hasName(el) {
    if (!el) return true;
    if ((el.getAttribute('aria-label') || '').trim()) return true;
    if ((el.getAttribute('aria-labelledby') || '').trim()) return true;
    if ((el.getAttribute('title') || '').trim()) return true;
    if ((el.textContent || '').trim()) return true;
    /* an <img> with alt text gives its link an accessible name */
    var img = el.querySelector('img[alt]');
    if (img && (img.getAttribute('alt') || '').trim()) return true;
    /* an inline <svg> with a <title> does too */
    var svgTitle = el.querySelector('svg > title');
    if (svgTitle && (svgTitle.textContent || '').trim()) return true;
    return false;
  }

  function nameLogo() {
    var logo = document.querySelector('header.theme-header #logo a, header.theme-header #identity #logo a');
    if (!logo) return;
    /* Prefer real alt text on the image — that names the link naturally
       and helps image search at the same time. */
    var img = logo.querySelector('img');
    if (img && !(img.getAttribute('alt') || '').trim()) {
      img.setAttribute('alt', SHOP_NAME);
    }
    if (!hasName(logo)) {
      logo.setAttribute('aria-label', SHOP_NAME + ' \u2014 home');
    }
  }

  function nameSearchControls() {
    var buttons = document.querySelectorAll(
      'form.header-search-form button, .large-search form button, #search-bar button, .search-button'
    );
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if (hasName(b)) continue;
      b.setAttribute('aria-label', 'Search');
    }
    /* the input itself should be labelled for screen readers */
    var inputs = document.querySelectorAll(
      'form.header-search-form input[type="search"], form.header-search-form input.header-search'
    );
    for (var j = 0; j < inputs.length; j++) {
      var inp = inputs[j];
      if ((inp.getAttribute('aria-label') || '').trim()) continue;
      if (inp.id && document.querySelector('label[for="' + inp.id + '"]')) continue;
      inp.setAttribute('aria-label', 'Search products');
    }
  }

  function run() {
    try {
      nameLogo();
      nameSearchControls();
    } catch (e) { /* never break the page over a label */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  /* one late pass in case an app injects its own search markup */
  setTimeout(run, 1500);
})();
